import { Card } from '@/components/ui/card';
import { format } from 'date-fns';
import { useAuth } from '@/contexts/AuthContext';
import { ScrollArea } from '@/components/ui/scroll-area';

interface Notification {
  id: string;
  message: string;
  created_at: string;
  is_from_admin: boolean;
  is_read: boolean;
  user_id: string | null;
  client_id: number | null;
  admin_id: string | null;
}

interface NotificationsListProps {
  notifications: Notification[];
}

export const NotificationsList = ({ notifications }: NotificationsListProps) => {
  const { isAdmin, user } = useAuth();
  console.log('Rendering notifications:', notifications);
  console.log('Current user:', user?.id);
  console.log('Is admin:', isAdmin);

  const renderMessage = (notification: Notification) => {
    const isFromMe = isAdmin ? notification.is_from_admin : !notification.is_from_admin;

    return (
      <div
        key={notification.id}
        className={`flex ${isFromMe ? 'justify-end' : 'justify-start'} mb-4`}
      >
        <div
          className={`max-w-[70%] rounded-lg p-3 ${
            isFromMe
              ? 'bg-blue-600 text-white ml-auto'
              : 'bg-gray-700 text-white'
          }`}
        >
          <p className="text-sm">{notification.message}</p>
          <p className="text-xs mt-1 opacity-70">
            {format(new Date(notification.created_at), 'PPpp')}
          </p>
        </div>
      </div>
    );
  };

  return (
    <Card className="p-4 bg-[#2A2F3C] border-gray-600">
      <h3 className="text-lg font-semibold text-white mb-4">
        {isAdmin ? "Chat with Client" : "Chat with Admin"}
      </h3>
      <ScrollArea className="h-[500px] pr-4">
        <div className="space-y-2">
          {notifications
            .sort((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime())
            .map(renderMessage)}
        </div>
      </ScrollArea>
    </Card>
  );
};